import { Box, Card, CardBody, CardHeader, Heading, Text } from '@chakra-ui/react'
import { useNavigate, useParams } from 'react-router-dom'
import { TaskTemplateForm } from '@/components/forms/TaskTemplateForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function TaskTemplateEditPage() {
  const colors = useThemeColors()
  const navigate = useNavigate()
  const { id } = useParams<{ id: string }>()
  const templateId = id ? Number(id) : undefined

  return (
    <Box p={4}>
      <Card>
        <CardHeader>
          <Heading size="md">Edit Task Template</Heading>
          <Text fontSize="sm" color={colors.textSecondary} mt={1}>
            Update steps and field configuration
          </Text>
        </CardHeader>
        <CardBody>
          {templateId ? (
            <TaskTemplateForm
              templateId={templateId}
              onSuccess={() => navigate('/service-catalog/task-templates')}
              onCancel={() => navigate('/service-catalog/task-templates')}
            />
          ) : null}
        </CardBody>
      </Card>
    </Box>
  )
}
